export default __webpack_public_path__ + "static/subset-UniNeueThin-Italic-a88d3593b9e99cf4aafe5b7d718d6b08.woff";